export const choices = ['auto', 'zh-CN', 'en'];
export function telegramLanguage(code) {
  return /^zh(?:[-_]|$)/i.test(String(code || '')) ? 'zh-CN' : 'en';
}
export function preferenceKey(userId) {
  return `xiaoqia:language:v1:${userId || 'guest'}`;
}
export function readPreference(storage, userId) {
  try {
    const value = storage?.getItem(preferenceKey(userId));
    return choices.includes(value) ? value : 'auto';
  } catch { return 'auto'; }
}
export function resolveLanguage(preference, code, last) {
  return preference === 'zh-CN' || preference === 'en' ? preference : code?telegramLanguage(code):['zh-CN','en'].includes(last)?last:'en';
}
export const storefrontPreferenceKey=userId=>`xiaoqia:store-language:v1:${userId||'guest'}`;
export function readStorefrontPreference(storage,userId) {
  try {const shared=storage?.getItem(preferenceKey(userId));if(choices.includes(shared))return shared;const value=storage?.getItem(storefrontPreferenceKey(userId));return choices.includes(value)?value:'auto';}catch{return 'auto';}
}
export function languageStorage(){try{return window.localStorage;}catch{return undefined;}}
export const lastLanguageKey=id=>`xiaoqia:language:last:v1:${id||'guest'}`;
export function readLastLanguage(storage,id){try{const value=storage?.getItem(lastLanguageKey(id));return ['zh-CN','en'].includes(value)?value:null;}catch{return null;}}
export function cacheLanguage(storage,id,preference,last){try{storage?.setItem(preferenceKey(id),preference);if(['zh-CN','en'].includes(last))storage?.setItem(lastLanguageKey(id),last);}catch{}}
